var normalizeFieldValue = function normalizeFieldValue(value) {
  if (value !== null && typeof value !== 'undefined' && typeof value.value !== 'undefined') {
    return value.value || undefined;
  }
  return value || undefined;
};
var createMinimumLengthValidator = function createMinimumLengthValidator(length) {
  return function (value) {
    return normalizeFieldValue(value) ? normalizeFieldValue(value).length >= length : true;
  };
};
var createRegularExpressionValidator = function createRegularExpressionValidator(regex) {
  return function (value) {
    return !!normalizeFieldValue(value) && !!regex.test(normalizeFieldValue(value));
  };
};
var intGtZero = function intGtZero(value) {
  return !!value && parseInt(value, 10) > 0 && value % 1 === 0;
};
var notEmpty = function notEmpty(value) {
  return !!normalizeFieldValue(value);
};
var intGteZero = function intGteZero(value) {
  return !!value && parseInt(value, 10) >= 0 && value % 1 === 0;
};
var selectedAndNotUndefined = function selectedAndNotUndefined(value) {
  return notEmpty(value) && value.value !== 'undefined';
};
export var PASSWORD_MIN_LENGTH = 10;

/**
 * These are common validators that are applicable to a large chunk of the codebase.
 * Any form-specific validator should be stored alongside the form requiring the
 * validator.
 */
export default {
  // validators
  chinesePhoneValid: function chinesePhoneValid(value) {
    return value && value.length === 11;
  },
  notEmpty: notEmpty,
  notEmptyString: function notEmptyString(value) {
    return value !== '';
  },
  notNull: function notNull(val) {
    return val !== null && val !== undefined;
  },
  gtZero: function gtZero(value) {
    return !!value && parseInt(value, 10) > 0;
  },
  intGtZero: intGtZero,
  intGteZero: intGteZero,
  floatGteZero: function floatGteZero(value) {
    return !!value && parseFloat(value) >= 0.0;
  },
  notFalse: function notFalse(value) {
    return value !== false;
  },
  selectedAndNotUndefined: selectedAndNotUndefined,
  emptyOrIntGtZero: function emptyOrIntGtZero(value) {
    return !notEmpty(value) || intGtZero(value);
  },
  emptyOrIntGteZero: function emptyOrIntGteZero(value) {
    return !notEmpty(value) || intGteZero(value);
  },
  isEmail: createRegularExpressionValidator(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
  validAlphaNumericCode: createRegularExpressionValidator(/^[A-Za-z0-9_-]+$/),
  validBrazilianState: createRegularExpressionValidator(/^[A-Z]{2}$/),
  // validation creators
  createRegularExpressionValidator: createRegularExpressionValidator,
  createMaximumLengthValidator: function createMaximumLengthValidator(length) {
    return function (value) {
      return normalizeFieldValue(value) ? normalizeFieldValue(value).length <= length : true;
    };
  },
  // @TODO CUSTOMER-TBD this validator needs to be fixed as well, but it has several usages that are
  // beyond the scope of this current task
  createMinimumLengthValidator: createMinimumLengthValidator,
  createExactLengthValidator: function createExactLengthValidator(length) {
    return function (value) {
      return normalizeFieldValue(value) ? normalizeFieldValue(value).length === length : true;
    };
  },
  validPassword: function validPassword(password) {
    var minimumLength = createMinimumLengthValidator(PASSWORD_MIN_LENGTH);
    return password && minimumLength(password);
  }
};